// extracted by mini-css-extract-plugin
module.exports = {"TimelineWrapper":"TimelineWrapper--rYhhv","ReduceTextSize":"ReduceTextSize--1dFEo","GroupLabel":"GroupLabel--6xblg","Loading":"Loading--2FjNh"};